import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/apiClient";
import { toast } from "sonner";

export default function Register() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", hotel_name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  function upd(k, v) { setForm((f) => ({ ...f, [k]: v })); }

  async function onSubmit(e) {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(form);
      toast.success("Welcome to Booking4U");
      navigate("/dashboard");
    } catch (e) {
      const msg = formatApiErrorDetail(e.response?.data?.detail) || e.message;
      setError(msg); toast.error(msg);
    } finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#0B101E]" data-testid="register-page">
      <div className="w-full max-w-xl">
        <Link to="/" className="inline-flex items-center gap-2 mb-10">
          <span className="w-9 h-9 rounded-md bg-[#D4AF37] flex items-center justify-center text-[#0B101E] font-bold font-display">B</span>
          <span className="font-display text-2xl">Booking4U</span>
        </Link>
        <div className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Start 30-day free trial</div>
        <h1 className="font-display text-4xl mb-2">Create your property account</h1>
        <p className="text-white/60 text-sm mb-8">No credit card required. Cancel anytime.</p>

        <form onSubmit={onSubmit} className="space-y-5">
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="text-xs uppercase tracking-widest text-white/50">Your name</label>
              <input required value={form.name} onChange={(e) => upd("name", e.target.value)} className="mt-2 w-full bg-[#12182B] border border-white/10 rounded-md px-4 py-3 focus:outline-none focus:border-[#D4AF37]/60" data-testid="register-name-input" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-white/50">Hotel / property name</label>
              <input required value={form.hotel_name} onChange={(e) => upd("hotel_name", e.target.value)} className="mt-2 w-full bg-[#12182B] border border-white/10 rounded-md px-4 py-3 focus:outline-none focus:border-[#D4AF37]/60" data-testid="register-hotel-input" />
            </div>
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-white/50">Work email</label>
            <input type="email" required value={form.email} onChange={(e) => upd("email", e.target.value)} className="mt-2 w-full bg-[#12182B] border border-white/10 rounded-md px-4 py-3 focus:outline-none focus:border-[#D4AF37]/60" data-testid="register-email-input" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-white/50">Password</label>
            <input type="password" required minLength={6} value={form.password} onChange={(e) => upd("password", e.target.value)} className="mt-2 w-full bg-[#12182B] border border-white/10 rounded-md px-4 py-3 focus:outline-none focus:border-[#D4AF37]/60" data-testid="register-password-input" />
            <div className="text-xs text-white/40 mt-2">Minimum 6 characters.</div>
          </div>
          {error && <div className="text-sm text-red-400" data-testid="register-error">{error}</div>}
          <button type="submit" disabled={loading} className="btn-gold w-full rounded-md py-3 disabled:opacity-60" data-testid="register-submit-button">
            {loading ? "Creating account…" : "Create account"}
          </button>
        </form>

        <div className="mt-6 text-sm text-white/50 text-center">
          Already have an account?{" "}
          <Link to="/login" className="text-[#D4AF37] hover:text-[#F2D06B]" data-testid="link-login">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
